<template>
  <div class="service-wrap">
    <divider chinese="服务理念" english="SERVICE CONCEPT" />
    <div class="service-con">
      <div class="service-item">
        <img src="@/assets/images/yun.png" alt="">
        <p>云享服务</p>
      </div>
      <div class="service-item">
        <img src="@/assets/images/meng.png" alt="">
        <p>智创梦想</p>
      </div>
      <div class="service-item">
        <img src="@/assets/images/weilai.png" alt="">
        <p>引领未来</p>
      </div>
      <div class="service-item">
        <img src="@/assets/images/qiancheng.png" alt="">
        <p>慧就前程</p>
      </div>
    </div>
  </div>
</template>

<script>
import divider from '@/components/common/divider';
export default {
  components: {
    divider
  }
};
</script>

<style lang="scss" scoped>
.service-wrap {
  @include container(1200px);
  margin-bottom: 53px;

  .service-con {
    display: flex;
    justify-content: space-between;

    .service-item {
      width: 270px;
      height: 300px;
      background: #fff;
      border: 1px solid #E6E6E6;
      text-align: center;

      &:hover {
        border: 1px solid $el-main-color;
      }

      img {
        width: 152px;
        height: 152px;
        display: block;
        margin: 31px auto 34px;
      }

      p {
        font-size: 24px;
        font-weight: 400;
        color: #333333;
        line-height: 26px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/service.vue